import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var CryptographyProviderClass;
function CryptographyProvider() {
  if (CryptographyProviderClass === VOID) {
    class $ {}
    initMetadataForClass($, 'CryptographyProvider');
    CryptographyProviderClass = $;
  }
  return CryptographyProviderClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  CryptographyProvider as CryptographyProviderwgv0x40nzvjc,
};
//endregion

//# sourceMappingURL=CryptographyProvider.mjs.map
